//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from "axios";
import EventCard from "./EventCard.vue";
import TicketverkoopCard from "./TicketverkoopCard.vue";
import WhdThuisCard from "./WhdThuisCard.vue";

export default {
  props: {
    siteUrl: String,
    postPerPage: Number,
    ticketStartDate: String,
    labels: {
      type: Array,
      required: true,
      default: () => []
    }
  },

  name: "ProgrammaComponent",
  components: { EventCard, TicketverkoopCard, WhdThuisCard },
  data() {
    return {
      data: [],
      tickets_sales_start: false,
      view: "list",
      hoveredExFilter: undefined,
      noData: false,
      loadMoreClicked: false,
      whdThuisSelected: false,
      loading: false,
      navigation: true,
      currentPosts: 0,
      offset: 15,
      deelnemersOptions: [],
      deelnemers1: [],
      deelnemers2: [],
      deelnemers3: [],
      eventOptions: [],
      dagOptions: [],
      detailsOptions: [
        {
          label: "Rolstoelvriendelijk",
          value: "rolstoelvriendelijk"
        },
        {
          label: "Engelstalig",
          value: "engelstalig"
        },
        {
          label: "Identificatie",
          value: "identificatie"
        }
      ],
      totalPost: 0,
      formData: {
        offset: 0,
        deelnemers: [],
        doelgroep: [],
        programma: [],
        post_type: [],
        whd_event_dates: [],
        details: [],
        whd_ticketavailable: [],
        excursie: []
      },
      deelnemerDropdown: false,
      deelnemerTrayOpened: false,
      deelnemerMobileTrayOpened: false,
      childCheckboxOpened: false,
      filtersTrayOpened: false,
      ticketIcons: {
        blue: require("../../images/icon-ticket-blue.svg"),
        grey: require("../../images/icon-ticket-grey.svg")
      },
      programmaTypes: [
        {
          label: "Schepen te bezoeken",
          term_id: "17"
        },
        {
          label: "Zien en beleven op de kades",
          term_id: "18",
          greyIcon: require("../../images/icon-anchor-grey.png"),
          whiteIcon: require("../../images/icon-anchor-white.png")
        },
        {
          label: "Excursies",
          term_id: "28",
          greyIcon: require("../../images/icon-group-grey.png")
        },
        {
          label: "Rondvaarten",
          term_id: "29",
          greyIcon: require("../../images/icon-ship-grey.png"),
          whiteIcon: require("../../images/icon-ship-white.png")
        },
        {
          label: "Nautische shows",
          term_id: "30",
          greyIcon: require("../../images/icon-fireworks-grey.png")
        },
        {
          label: "Wereldhavendagen thuis / bij jou in huis",
          term_id: "31"
        },
        {
          label: "Educatie",
          term_id: "32"
        },
        {
          label: "Meer te doen in de stad",
          term_id: "33"
        }
      ],
      excursieTypes: [
        {
          name: "Bootexcursie",
          term_id: 43
        },
        {
          name: "Busexcursie",
          term_id: 14
        },
        {
          name: "Fietsexcursie",
          term_id: 44
        },
        {
          name: "Wandelexcursie",
          term_id: 18
        }
      ]
    };
  },
  computed: {
    // get the total favourite and display it on tops
    // favouriteCount: function() {
    //   return this.favourites.length;
    // },
    // Get total filters live
    filtersCount() {
      const {
        deelnemers,
        programma,
        doelgroep,
        whd_event_dates,
        details,
        whd_ticketavailable,
        excursie
      } = this.formData;
      return (
        deelnemers.length +
        programma.length +
        doelgroep.length +
        whd_event_dates.length +
        details.length +
        whd_ticketavailable.length +
        excursie.length
      );
    }
  },
  mounted() {
    this.getURLHash();
    this.loadDeelnemers(); // Loads a list of optopns
    this.loadOptions();
    this.checkWHDThuis();
    if (Array.isArray(this.labels)) {
      this.dagOptions = this.labels.map(label => ({
        longLabel: label.longLabel,
        shortLabel: label.shortLabel,
        value: label.value
      }));

      // console.log("dagOptions:", this.dagOptions);
    } else {
      console.error("Labels prop is not an array.");
    }
  },
  methods: {
    hidefilter() {
      // console.log('ya');
      if (this.deelnemerTrayOpened) {
        // console.log('tray is opened');
        this.deelnemerTrayOpened = false;
        this.getURLHash();
      }
    },
    getURLHash() {
      if (window.location.hash) {
        const hash = window.location.hash.substr(1);
        const splitHash = hash.split("&");
        splitHash.map(item => {
          const splitParam = item.split("=");
          // If no value found after '=', then return empty array
          if (splitParam[1] === "") {
            this.formData[splitParam[0]] = [];
          } else {
            this.formData[splitParam[0]] = splitParam[1].split(",");
          }
        });

        this.loadProgrammes(false);
      } else {
        this.loadProgrammes(false);
      }
    },

    loadOptions() {
      axios.get(`${this.siteUrl}/wp-json/events/v2/get_fields`).then(res => {
        this.parseOptions(res.data);
        // console.log('loadOptions: ', res.data)
      });
      console.log("from programma: ", window.location.origin);
    },

    loadDeelnemers() {
      axios
        .get(`${this.siteUrl}/wp-json/deelnemers/v2/list-by-events`)
        .then(res => {
          this.deelnemersOptions = res.data;
          this.splitDeelneemers(res.data);
        });
    },

    splitDeelneemers(data) {
      const oneThird = data.length / 3;
      const twoThird = oneThird * 2;

      data.map((deel, index) => {
        if (index < oneThird) {
          this.deelnemers1.push(deel);
        } else if (index >= oneThird && index < twoThird) {
          this.deelnemers2.push(deel);
        } else {
          this.deelnemers3.push(deel);
        }
      });
    },

    //parse the options from object to array
    parseOptions(data) {
      const objToArray = Object.keys(data).reduce((accumulator, item) => {
        const childItem = data[item];
        const children = Object.keys(childItem).reduce(
          (accumulator2, childKey) => {
            return [...accumulator2, childItem[childKey]];
          },
          []
        );

        // sort the children by name
        if (item === "doelgroep" || item === "excursie") {
          this.sortAlphanumerically(children, "name");
        }

        return { ...accumulator, [item]: children };
      }, {});

      this.eventOptions = objToArray;
    },

    sortAlphanumerically(arrayOfObjects, compareKey) {
      arrayOfObjects.sort((a, b) => {
        const strA = a[compareKey];
        const strB = b[compareKey];
        // check if first character of string is a finite number
        // if not, compare string to sort alphabetically and numerically
        return (
          isFinite(strA[0]) - isFinite(strB[0]) ||
          strA.localeCompare(strB, undefined, {
            numeric: true,
            sensitivity: "base"
          })
        );
      });
    },

    //main function of loading posts
    loadProgrammes(loadMore = false, toepassenBtn = false) {
      if (!loadMore) {
        this.loading = true;
        this.formData.offset = 0;
        this.currentPosts = 0;
        this.navigation = true;
      } else {
        this.loadMoreClicked = true;
      }

      if (toepassenBtn) {
        this.toggleDeelnemerTray();
        this.toggleDeelnemerMobileTray();
      }

      //converts array to comma delimiter string for the params
      const fD = Object.entries(this.formData).reduce((newObj, [key, val]) => {
        if (key === "offset" || key === "posts_per_page") {
          newObj[key] = val;
        } else {
          if (key.length > 0) {
            newObj[key] = val.join();
          } else {
            return;
          }
        }
        return newObj;
      }, {});

      let url =
        // `${this.siteUrl}/wp-json/dpd/v2/my_meta_query`;
        `${this.siteUrl}/wp-json/events/v2/my_meta_query`;

      axios
        .get(url, {
          params: fD // Need to figure out how to configure the parameters
        })
        .then(response => {
          this.tickets_sales_start = response.data.tickets_sales_start;

          if (response.data.message !== undefined) {
            this.noData = true;
            this.data = [];
          } else {
            this.noData = false;
            this.totalPost = response.data.total;

            // console.log("data RESH", response.data.data);

            // Convert response.data.data to JSON and log it
            // const dataJson = JSON.stringify(response.data.data, null, 2);
            // console.log("data RESH json", dataJson);

            this.currentPosts =
              this.currentPosts + this.objectLength(response.data.data);
            if (
              response.data.total <= this.offset ||
              this.currentPosts >= this.totalPost
            ) {
              this.navigation = false;
            }
            console.log("loadmore", loadMore);

            if (loadMore) {
              this.data = [...this.data, ...response.data.data];
            } else {
              this.data = response.data.data;
            }
          }

          this.loading = false;
          this.loadMoreClicked = false;
          this.checkWHDThuis();
        });
    },

    toggleDeelnemerFilters() {
      this.deelnemerDropdown = !this.deelnemerDropdown;
    },

    toggleDeelnemerTray() {
      this.deelnemerTrayOpened = !this.deelnemerTrayOpened;
    },

    toggleDeelnemerMobileTray() {
      // document.body.style.backgroundColor = 'purple';
      this.deelnemerMobileTrayOpened = !this.deelnemerMobileTrayOpened;

      let screenWidth = window.innerWidth;

      // Only for mobile screen size
      if (this.deelnemerMobileTrayOpened && screenWidth < 640) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "scroll";
      }
    },

    toggleChildCheckbox() {
      this.childCheckboxOpened = !this.childCheckboxOpened;
    },

    toggleFiltersTray() {
      this.filtersTrayOpened = !this.filtersTrayOpened;
    },

    toggleViews(type) {
      this.view === type;
    },

    selectFilter(filterType, payload, isExclusive = false) {
      if (payload === "all") {
        // this.formData[filterType] = [];
        this.formData = {
          offset: 0,
          deelnemers: [],
          doelgroep: [],
          programma: [],
          post_type: [],
          whd_event_dates: [],
          details: [],
          whd_ticketavailable: [],
          excursie: []
        };

        // Load upon selection of filters
        this.loadProgrammes(false);
      } else {
        if (isExclusive) {
          const selected = this.formData[filterType].findIndex(selected => {
            return payload.toString() === selected.toString();
          });

          // element was found, index provided and removed from formData
          if (selected !== -1) {
            this.formData[filterType].splice(selected, 1);
          } else {
            this.formData[filterType].push(payload);
          }

          // Load upon selection of filters
          this.loadProgrammes(false);
        } else {
          const selected = this.formData[filterType].findIndex(selected => {
            return payload.toString() === selected.toString();
          });

          // element was found, index provided and removed from formData
          if (selected !== -1) {
            this.formData[filterType].splice(selected, 1);
          } else {
            this.formData[filterType].push(payload);
          }
        }
      }
    },

    //check if the filter is currently selected, better for this in computed?
    checkIfSelected(type, payload) {
      // Returns the id/value of the filter or undefined
      const checkSelection = this.formData[type].find(item => {
        return payload.toString() === item.toString();
      });

      // console.log('Slection: ', checkSelection)
      return checkSelection;
    },

    loadMore() {
      // console.log('loading ah...');
      this.formData.offset = this.formData.offset + parseInt(this.offset);
      this.loadProgrammes(true);
    },

    objectLength(object) {
      var length = 0;
      for (var key in object) {
        if (object.hasOwnProperty(key)) {
          ++length;
        }
      }
      return length;
    },

    clearAllFilters(trayVersion) {
      if (trayVersion === "mobile") {
        this.toggleDeelnemerMobileTray();
      } else if (trayVersion === "desktop") {
        this.toggleDeelnemerTray();
      }

      if (this.formData.deelnemers.length > 0) {
        this.formData.deelnemers = [];
      }

      if (this.formData.programma.length > 0) {
        this.formData.programma = [];
      }

      if (this.formData.whd_event_dates.length > 0) {
        this.formData.whd_event_dates = [];
      }

      if (this.formData.doelgroep.length > 0) {
        this.formData.doelgroep = [];
      }

      if (this.formData.details.length > 0) {
        this.formData.details = [];
      }

      if (this.formData.whd_ticketavailable.length > 0) {
        this.formData.whd_ticketavailable = [];
      }

      if (this.formData.excursie.length > 0) {
        this.formData.excursie = [];
      }

      this.loadProgrammes(false);
    },

    checkWHDThuis() {
      if (window.location.hash) {
        const hash = window.location.hash.substr(1);
        const splitHash = hash.split("&");
        const findProgramma = splitHash.find(param => {
          const item = param.split("=");
          return item[0] === "programma";
        });
        const programmValue = findProgramma.split("=");
        const valueArray = programmValue[1].split(",");
        // console.log(valueArray.includes(whd_thuisID));
        this.whdThuisSelected = valueArray.includes("26");
      }
      // console.log(splitHash['programma']);
    }
  },
  watch: {
    //watch for changes on formData and append the hash to the URL
    formData: {
      handler() {
        const {
          deelnemers,
          programma,
          doelgroep,
          whd_event_dates,
          details,
          whd_ticketavailable,
          excursie
        } = this.formData;
        // const postType = post_type.length > 0 ? post_type : 'all';
        // const deel = deelnemer.length > 0 ? deelnemer : 'all';
        const hash = `deelnemers=${deelnemers}&programma=${programma}&doelgroep=${doelgroep}&whd_event_dates=${whd_event_dates}&details=${details}&whd_ticketavailable=${whd_ticketavailable}&excursie=${excursie}`;
        window.location.hash = hash;
      },
      deep: true
    }
  },
  directives: {
    "click-outside": {
      bind: function(el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== "function") {
          const compName = vNode.context.name;
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
          if (compName) {
            warn += `Found in component '${compName}'`;
          }

          console.warn(warn);
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble;
        const handler = e => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;

        // add Event Listeners
        document.addEventListener("click", handler);
      },

      unbind: function(el, binding) {
        // Remove Event Listeners
        document.removeEventListener("click", el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      }
    }
  }
};



// WEBPACK FOOTER //
// ./scripts/vue/ProgrammaComponent.vue